import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';

/**
 * فیلتر فعالیت منابع
 */
export const PublishRateFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, className } = props;
  const value = useSelector(
    (state) =>
      state[state.filterReducer.filtersContext].filters[componentName].value
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );

  const { setPublishRateValue } = getCurrentSlice(reducerName);

  const handleChange = (event) => {
    dispatch(
      setPublishRateValue({
        value: event.target.checked,
        componentName,
      })
    );
  };

  return (
    <div className={classNames('grid mb-12', className)}>
      <UiFormControlLabel
        key='want_active_resources'
        className='mr-0'
        label={t('filter:notShowInactiveResources')}
        control={
          <UiCheckbox
            name='want_active_resources'
            checked={value ?? false}
            onChange={(event) => handleChange(event)}
          />
        }
      />
    </div>
  );
};

PublishRateFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  className: PropTypes.string,
};
